import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import Links from "../../../Links";
import Src1 from "../../../../img/upvote-light.png";
import Src2 from "../../../../img/upvote-dark.png";

const UpVoteProjectSection = styled(ProjectSection)`
  background: rgb(98, 39, 163);
`;

const Button = styled(Links)`
  display: block;
  background-color: rgba(0, 0, 0, 0.05);
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  font-size: var(--font-size-text-small);
  &:hover,
  &:active {
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
  }
  &:visited {
    color: white;
  }
  &:focus {
    outline-color: white;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: auto;
  justify-content: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-large);

  @media (min-width: 500px) {
    grid-template-columns: auto;
  }
`;

function UpVote() {
  return (
    <UpVoteProjectSection>
      <ProjectTitle title="UpVote" tag="2026" />
      <ProjectSectionSkills>
        <Badge small title="AI">
          <Icons type="ai-small" />
        </Badge>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
        <Badge tooltip="large" small title="Web Components">
          <Icons type="web-components-small" />
        </Badge>
        <Badge small title="React">
          <Icons type="react-small" />
        </Badge>
      </ProjectSectionSkills>

      <ProjectDescription>
        UpVote helps users capture and prioritise opportunities and commitments in one place. It supports tracking for
        potential job opportunities, OKRs, travel plans, bills, and ongoing priorities. Items can be upvoted to
        surface what matters most, helping the highest-priority tasks rise to the top. The interface is built using
        Muibook Web Components.
      </ProjectDescription>

      <ButtonGroup>
        <Button href="https://upvote.redactd.xyz" color="white" target="_blank" rel="noopener noreferrer">
          View app
        </Button>
      </ButtonGroup>

      <ProjectHeroImage srcMobile1={Src1} srcMobile2={Src2} mobile thinBorder />
    </UpVoteProjectSection>
  );
}

export default UpVote;
